export const deDE = {
   "name": { label: "Name", help: "Ein eindeutiger Name für den Datensatz." },
   "description": { label: "Beschreibung", help: "Eine detailliertere Beschreibung des Datensatzes." },
   "shortName": { label: "Kurzer Name", help: "Ein eindeutiger Kurzname für den Datensatz." },
   "sort": { label: "Position sortieren", help: "Die Standardposition des Datensatzes in einer Liste." },
   "workingGroup_name": { help: "Ein eindeutiger Name für die Arbeitsgruppe." },
   "workingGroup_description": { help: "Der Zweck der Arbeitsgruppe." },
   "workingGroup_accessGroupName": { label: "Zugriffsgruppe", help: "Der Name der Gruppe, die zum Erteilen von Bearbeitungsberechtigungen verwendet wird." },
   "workingGroup_baseProfileUri": { label: "Basisprofil-URI", help: "Der Basis-URI für alle von der Arbeitsgruppe definierten Profile." },
};